import { Box, Typography } from '@mui/material'
import React from 'react'
import { bgColor15, blueColor1, greyColor9, whiteColor } from '../../configs/styles/muiThemes';
import { scrollBox } from "../../utils/styles";

function OrderMobileTab({
  ORDER_STATUS,
  tabValue,
  handleChange,
  getOrderCoutByStatus,
}) {
  return (
    <Box mt={1}>
      <Box
        display="flex"
        flexDirection="row"
        overflow="hidden"
        sx={{
          ...scrollBox,
          backgroundColor: "#e6e8ed",
          borderRadius: "6px",
          gap: 0,
        }}
      >
        {ORDER_STATUS?.map((item, index) => {
          return (
            <Box
              padding="5px 40px"
              backgroundColor={tabValue >= index ? "#8593ac" : "#e6e8ed"}
              onClick={() => {
                handleChange("", item.id);
              }}
              sx={{
                position: "relative",
                whiteSpace: "nowrap",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  display:
                    index === ORDER_STATUS.length - 1 ? "none" : "inline-block",
                  width: "36px",
                  height: "36px",
                  top: "-1px",
                  right: "-18px",
                  background: tabValue >= index ? "#8593ac" : "#e6e8ed",
                  //   {
                  //     xs: item.id === tabValue ? bgColor15 : whiteColor,
                  //     md: "transparent",
                  //   },
                  borderRight: `2px solid ${
                    tabValue >= index ? "#e6e8ed" : "#8593ac"
                  }`,
                  //   {
                  //     xs: `2px solid ${
                  //       item.id === tabValue ? whiteColor : bgColor15
                  //     }`,
                  //     md: "none",
                  //   },
                  borderBottom: `2px solid ${
                    tabValue >= index ? "#e6e8ed" : "#8593ac"
                  }`,
                  //   {
                  //     xs: `2px solid ${
                  //       item.id === tabValue ? whiteColor : bgColor15
                  //     }`,
                  //     md: "none",
                  //   },
                  borderRadius: "5px",
                  transform: "scale(0.707) rotate(-45deg)",
                  // boxShadow: "2px -2px rgb(192 196 204)",
                  zIndex: 16,
                },
              }}
            >
              <Typography
                fontSize={12}
                fontWeight={500}
                color={`${tabValue >= index ? whiteColor : bgColor15}`}
              >
                {item.label === "NEW/PENDING APPROVAL" ? "NEW" : item.label} -{" "}
                {getOrderCoutByStatus(index)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default OrderMobileTab

// const styles = {
//   arrow:{fontSize: { xs: "11px", md: "13px" },
//                       //   fontWeight: tabValue == index ? 600 : 500,
//                       p: { xs: "10px 35px 10px 10px", md: 0 },
//                       minHeight: "30px !important",
//                       mr: { xs: "0px", md: "55px" },
//                       color: {
//                         md: item.id === item.label ? blueColor1 : greyColor9,
//                         xs:
//                          item.id === item.label ? whiteColor : bgColor15,
//                       },
//                       backgroundColor: {
//                         xs: item.id === item.label ? bgColor15 : whiteColor,
//                         md: item.id === item.label ? bgColor15 : whiteColor,
//                         // md: "transparent",
//                       },
//                       "&::after": {
//                         content: '""',
//                         position: "absolute",
//                         display: "inline-block",
//                         width: "35px",
//                         height: "35px",
//                         top: "0px",
//                         right: "-20px",
//                         background: {
//                           xs: item.id === item.label ? bgColor15 : whiteColor,
//                           md: "transparent",
//                         },
//                         borderRight: {
//                           xs: `2px solid ${
//                             item.id === item.label ? whiteColor : bgColor15
//                           }`,
//                           md: "none",
//                         },
//                         borderBottom: {
//                           xs: `2px solid ${
//                             item.id === item.label ? whiteColor : bgColor15
//                           }`,
//                           md: "none",
//                         },
//                         borderTopRightRadius: "5px",
//                         transform: "scale(0.707) rotate(-45deg)",
//                         boxShadow: "2px -2px rgb(192 196 204)",
//                         zIndex: 16,
//                       },
                    
//   }
// };